<template>
  <v-container>
    <h2 class="mt-5 mb-3">Bosses</h2>

    <v-row justify="center" class="mt-6 mb-6">
      <v-btn color="primary" @click="openBossDialog()">Add a boss</v-btn>
    </v-row>

    <v-data-table
        :headers="headers"
        :items="bosses"
        :search="search"
        sort-by="name"
        fixed-header
        hide-default-footer
        disable-pagination>
      <template v-slot:top>
        <v-text-field
            v-model="search"
            label="Search bosses"
            append-icon="mdi-magnify"
            class="mx-4"
        ></v-text-field>
      </template>

      <template v-slot:item.image="{ item }">
        <v-img v-if="item.image" :src="item.image.url" max-width="100" max-height="80"></v-img>
      </template>
      <template v-slot:item.edit="{ item }">
        <v-btn color="primary" text @click="openBossDialog(item)">Edit</v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="bossDialog" max-width="700">
      <v-card>
        <v-card-title>{{ selectedBoss.id ? 'Edit' : 'New' }} boss</v-card-title>
        <v-card-text>
          <v-form ref="bossForm" v-model="validBoss">
            <v-text-field
                v-model="selectedBoss.name"
                label="Name"
                :rules="[v => !!v || 'Name is required']"
                outlined
                required></v-text-field>
            <v-text-field
                v-model.number="selectedBoss.index"
                label="Order"
                type="number"
                :rules="[v => Number.isInteger(Number(v)) && Number(v) >= 0 || 'Order must be a non-negative integer']"
                outlined
                required></v-text-field>
            <v-text-field
                v-model.number="selectedBoss.maxHealth"
                label="Maximum health"
                type="number"
                :rules="[v => Number(v) > 0 || 'Maximum health must be greater than 0']"
                outlined
                required></v-text-field>
            <document-upload v-model="selectedBoss.image" label="Image"></document-upload>
            <document-upload v-model="selectedBoss.background" label="Background"></document-upload>
            <document-upload v-model="selectedBoss.thumbnail" label="Thumbnail"></document-upload>
            <document-upload v-model="selectedBoss.announcementImage" label="Announcement image"></document-upload>
            <document-upload v-model="selectedBoss.music" label="Music" accept="audio/*"></document-upload>
            <h3 class="mb-3">Sounds</h3>
            <v-row v-for="(sound, index) in selectedBoss.sounds" :key="index" align="center">
              <v-col>
                <document-upload
                    :value="sound"
                    label="Sound"
                    accept="audio/*"
                    removable
                    :remove-label="`Remove sound ${index + 1}`"
                    @input="$set(selectedBoss.sounds, index, $event)"
                    @remove="selectedBoss.sounds.splice(index, 1)"></document-upload>
              </v-col>
            </v-row>
            <v-btn type="button" text color="primary" @click="selectedBoss.sounds.push(null)">Add a sound</v-btn>
            <v-select
                v-model="selectedBoss.favoriteChoice"
                :items="battleChoices"
                label="Favorite choice"
                clearable
                outlined></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="bossDialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click="saveBoss">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="6000" :color="snackbarColor" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">OK</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
import DocumentUpload from '@/components/DocumentUpload';

export default {
  name: 'Bosses',

  components: {
    DocumentUpload
  },

  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Order', value: 'index' },
        { text: 'Maximum health', value: 'maxHealth' },
        { text: 'Image', value: 'image', sortable: false },
        { text: '', value: 'edit', filterable: false, sortable: false }
      ],
      battleChoices: ['ATTACKER', 'DEFENDER', 'SPECIALIST'],
      search: '',
      bosses: [],
      bossDialog: false,
      validBoss: false,
      selectedBoss: {},
      snackbar: false,
      snackbarColor: 'success',
      snackbarText: ''
    }
  },

  methods: {
    loadBosses() {
      axios.get('/boss')
        .then(response => {
          this.bosses = response.data;
        })
        .catch(() => {
          this.showSnackbar('Error loading bosses', 'error');
        });
    },

    openBossDialog(boss) {
      this.selectedBoss = boss
        ? JSON.parse(JSON.stringify(boss))
        : {
          name: '',
          index: 0,
          maxHealth: null,
          image: null,
          background: null,
          thumbnail: null,
          announcementImage: null,
          music: null,
          sounds: [],
          favoriteChoice: null
        };
      this.selectedBoss.sounds = this.selectedBoss.sounds || [];
      this.bossDialog = true;
    },

    saveBoss() {
      if (!this.$refs.bossForm.validate()) {
        return;
      }

      const boss = {
        ...this.selectedBoss,
        sounds: this.selectedBoss.sounds.filter(Boolean)
      };

      axios.post('/boss', boss)
        .then(() => {
          this.bossDialog = false;
          this.showSnackbar('Boss saved successfully', 'success');
          this.loadBosses();
        })
        .catch(() => {
          this.showSnackbar('Error saving boss', 'error');
        });
    },

    showSnackbar(message, color) {
      this.snackbarText = message;
      this.snackbarColor = color;
      this.snackbar = true;
    }
  },

  created() {
    this.loadBosses();
  }
}
</script>
